import Helper from './helper'
import Is from './is.js'
import TomSelect from 'tom-select'

export default class Form
{
	static init()
	{
		this.select_picker()
		this.file_image()
		this.file_input()
		this.text_editor()
		this.limit_number_input()
	}

	static select_picker()
	{
		$('select.__select').each((index, element) =>
		{
			const plugin = {}

			if(element.nodeName === 'SELECT' && element.multiple) plugin.remove_button = {title: '削除'}
			if(!$(element).hasClass('__select-no-search')) plugin.dropdown_input = {}

			new TomSelect(element, {
				plugins                  : plugin,
				allowEmptyOption         : true,
				showEmptyOptionInDropdown: true,
				maxOptions               : 100000,
			})
		})
	}

	static file_image()
	{
		const input_image = $('input.__image_select[type="file"]')

		input_image.each((index, input) =>
		{
			const preview = $(input).data('preview')
			if(!Is.filled(preview)) return

			const tag = document.querySelector(preview)
			if(!tag) return

			const original = tag.src

			input.addEventListener('change', function()
			{
				//@ts-ignore
				tag.src = this.files.length > 0 ? URL.createObjectURL(this.files[0]) : original
				tag.parentNode.href = tag.src
			})
		})
	}

	static file_input()
	{
		const language = Helper.message('#message-file_select')

		$('input[type="file"]:not([class="__image_select"])').jfilestyle({
			text : language ?? 'ファイル選択',
			badge: true,
			input: false,
		})
	}

	static text_editor()
	{
		if($('.__editor').length === 0) return

		$('.__editor').each((index, element) =>
		{
			ClassicEditor.create(element, {
				width: 'auto',
				image: {
					resizeUnit: 'px',
				},
				link : {
					decorators: {
						isExternal: {
							mode      : 'manual',
							label     : 'Open in a new tab',
							attributes: {
								target: '_blank',
							},
						},
					},
				},
			}).then(editor =>
			{
				$(element).data('editor', editor)
			})
		})
	}

	static limit_number_input()
	{
		$('input[type="number"]').each((index, element) =>
		{
			element.addEventListener('input', function() { this.value = this.value.slice(0, this.maxLength) })
		})
	}
}
